export default class SaldoBancoHoras {
    constructor() {
        this.id = null;
        this.data = new Date();
        this.horas = null;
        this.minutos = null;
        this.valorNegativo = false;
    } 
}